import { __assign, __spreadArray } from "tslib";
/**
 * @param streamState
 * @param action
 */
export var handleInsertItemsAtOffsetAndSetCursorAction = function (streamState, action) {
    var newTotal = streamState.total !== undefined
        ? streamState.total + action.items.length
        : undefined;
    // Prepend - optimisation concat faster than slice and spread
    if (action.offset === 0) {
        return __assign(__assign({}, streamState), { cursor: action.newCursor || streamState.cursor, items: action.items.concat(streamState.items || []), total: newTotal });
    }
    // Append - optimisation concat faster than slice and spread
    if (action.offset === streamState.items.length) {
        return __assign(__assign({}, streamState), { cursor: action.newCursor || streamState.cursor, items: (streamState.items || []).concat(action.items), total: newTotal });
    }
    // Inject
    var current = streamState.items || [];
    var newItems = __spreadArray(__spreadArray(__spreadArray([], current.slice(0, action.offset), true), action.items, true), current.slice(action.offset), true);
    return __assign(__assign({}, streamState), { cursor: action.newCursor || streamState.cursor, items: newItems, total: newTotal });
};
//# sourceMappingURL=actionHandlers.js.map